import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
  Container,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import {
  getFactorsCriteria,
  editFactorCriterion
} from "../../../redux/descriptorsProfiles/FactoresCriterios/actions";

import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

const schema = Yup.object().shape({
  aplicable: Yup.number().required("**Campo requerido")
});

const FactorsAndCriteria = (props) => {
  //* States
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [filter, setFilter] = useState("");
  const [editItem, setEditItem] = useState({});
  const [validated, setValidated] = useState(false);
  const [mantIndkator, setMantIndkator] = useState(null);
  const [unitMeasu, setUnitMeasu] = useState(null);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre_factor", desc: "Nombre del Factor"
  });
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false)
  const [busqAnio, setBusqAnio] = useState(moment().year())

  //* Redux

  const {
    loaderFactorsCriteria,
    factorsCriteria,
    factorsCriteriaFail,
    formFactorCriterionFail,
    saveLoaderFactorCriterion,
    factorsCriteriaLenght
  } = useSelector((store) => store.descriptorFactorCriterion);

  //* variables
  const dispatch = useDispatch();
  const codResponsable = useSelector((store) => store.auth.username);
  const userRoles = useSelector((store) => store.auth.userRoles);

  let countSelected = 0;

  if(factorsCriteria && factorsCriteria.length > 0) {
    countSelected = factorsCriteria.reduce((acc, curr) => {
      return curr.aplicable === true ? acc + 1 : acc;
    }, 0);
  }
  


  const pages = Math.ceil((factorsCriteria ? factorsCriteriaLenght : 0) / limit);
  const columns = [
    {
      Header: "Factor",
      accessor: "nombre_factor",
      Filter: "",
      Cell: (value) => {
        const factoresCriterios = value.row.original?.list_factores_criterios;
        const factorCriticidad = factoresCriterios && factoresCriterios[0]?.list_factor_criticidad;

        return (
          <div>
            {factorCriticidad && factorCriticidad[0]
              ? factorCriticidad[0].nombre
              : "No ingresado"}
          </div>
        );
      }
    },
    {
      Header: "Responsable",
      accessor: "nombre_responsable",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_unidad_organizativa &&
            value.row.original.list_unidad_organizativa[0]
            ? value.row.original.list_unidad_organizativa[0].nombre
            : "No ingresado"}
        </div>
      ),
    },

    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      Header: "Aplica",
      id: "aplica",
      Filter: "",
      Cell: ({ row }) => (
        <Formik
          initialValues={{ aplicable: row?.original?.aplicable }}
          validationSchema={Yup.object({
            aplicable: Yup.boolean().required("**Campo requerido")
          })}
          onSubmit={(values) => {
            const updateData = { aplicable: values.aplicable == false ? "0" : "1" };
            // Llama a la acción de Redux para actualizar el elemento
            dispatch(editFactorCriterion(updateData, row.original.id, row.index));
          }}
        >
          {({ handleSubmit, values, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Form.Check
                type="switch"
                id={`custom-switch-${row.index}`}
                label={values.aplicable ? "Aplica" : "No Aplica"}
                checked={values.aplicable}
                onChange={(e) => {
                  setFieldValue("aplicable", e.target.checked);
                  handleSubmit();
                }}
                role="button"
              />
            </Form>
          )}
        </Formik>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            className="text-dark"
            variant="link"
            type="button"
            onClick={() => onSeeDetails(value.row.original)}
          >
            <i className="material-icons">visibility</i>
          </Button>

        </div>
      ),
    },
  ];
  const filters = [
    { id: "nombre_factor", desc: "Nombre del Factor" },
    { id: "nombre_criterio", desc: "Nombre del Criterio" },
    { id: "nombre_area", desc: "Nombre del Área" },
    { id: "codigo_area", desc: "Código del Área" },
    { id: "nombre_responsable", desc: "Nombre del Responsable" },
    { id: "codigo_responsable", desc: "Código del Responsable" }

  ];
  //* Method
  const _getFactorsCriteria = (offs = offset, lim = limit) => {
    let filt
    let busqueda = {}
    if (userRoles.length > 0) {
      if (userRoles.includes("administrador") || userRoles.includes("Responsable_Carrera_Sucesion")) {
        busqueda = { id: "nombre_factor", desc: "Nombre del Factor" }

        filt = filter
      } else {
        busqueda = { id: "codigo_responsable", desc: "Código del Responsable" }
        filt = codResponsable
      }

    }
    setTipoBusqueda(busqueda)
    dispatch(
      getFactorsCriteria({
        offset: offs,
        limit: lim,
        tipo_busqueda: busqueda.id,
        filter: filt,
        descriptor: props.match.params.id,
        anio: busqAnio
      })
    );
  }




  useEffect(() => {
    _getFactorsCriteria();
  }, []);

  useEffect(() => {
    _getFactorsCriteria();
  }, [busqAnio]);

  const getYears = () => {
    const years = Array.from({ length: 6 }, (_, i) => moment().year() - i);
    return years;
  }

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactorsCriteria(oOffset, limit, e.target.filter.value);
  };


  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactorsCriteria(oOffset, limit, oSearch);
  };

  const onSeeDetails = (item) => {
    setShowDetails(true);
    setShowDetailsModal(true);
    setEditItem(item);
  }

  return (
    <div className="mt-5">
      <Container>
        <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="text-black-50 m-0">Factores y Criterios</h5>
          {(userRoles.includes("administrador") || userRoles.includes("responsable_carrera_sucesion")) && (
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>

                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip {...props}>Seleccionar Filtrado</Tooltip>}
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>

                  </ButtonGroup>
                </Col>

              </Form.Row>

            </Form>)}

        </div>
        <div className="px-2">
          <hr />
        </div>
        <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
          <Form>
            <Form.Row>
              <Col lg={3}>
                <Form.Label>
                  <b>Seleccione un Año</b>
                </Form.Label>
                <Form.Control
                  as="select"
                  id="anio"
                  name="anio"
                  className="col rounded-pill ml-3 mr-3"
                  value={busqAnio}
                  onChange={(e) => {
                    setBusqAnio(e.currentTarget.value)
                  }}
                >
                  <option
                    className="text-muted"
                    value=""
                    selected
                    disabled
                  >
                    Año
                  </option>
                  {getYears().map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Form.Row>

          </Form>
        </div>
        <Modal
          show={showDetailsModal}
          onHide={() => {
            setShowDetailsModal(false);
          }}
        >
          <Form>
            <Modal.Header closeButton>
              <Modal.Title className="text-muted">
                Más Detalles
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>


              <Form.Group className="mb-3">

                <h6 className="my-2">Factor Criterio</h6>
                <Form.Label column sm="12" md="12">
                  Función:
                </Form.Label>
                <Row className="d-flex flex-wrap align-items-center">
                  <Col sm={11} xs={11}>
                    <Form.Control
                      type="text"
                      placeholder=""
                      aria-label="Disabled input example"
                      readOnly
                      value={showDetails ? `${editItem.list_factores_criterios[0].list_funcion[0].codigo} / ${editItem.list_factores_criterios[0].list_funcion[0].descripcion}` : ""}

                    />
                  </Col>
                </Row>
                <Form.Label column sm="12" md="12">
                  Criterio:
                </Form.Label>
                <Row className="d-flex flex-wrap align-items-center">
                  <Col sm={11} xs={11}>
                    <Form.Control
                      type="text"
                      placeholder=""
                      aria-label="Disabled input example"
                      readOnly
                      value={showDetails ? editItem.list_factores_criterios[0]?.list_criterios[0]?.nombre : ""}

                    />
                  </Col>
                </Row>
                <Form.Label column sm="12" md="12">
                  Factor:
                </Form.Label>
                <Row className="d-flex flex-wrap align-items-center">
                  <Col sm={11} xs={11}>
                    <Form.Control
                      type="text"
                      placeholder=""
                      aria-label="Disabled input example"
                      readOnly
                      value={showDetails ? editItem.list_factores_criterios[0].list_factor_criticidad[0].nombre : ""}

                    />
                  </Col>
                </Row>
                <Form.Label column sm="12" md="12">
                  Peso:
                </Form.Label>
                <Row className="d-flex flex-wrap align-items-center">
                  <Col sm={11} xs={11}>
                    <Form.Control
                      type="text"
                      placeholder=""
                      aria-label="Disabled input example"
                      readOnly
                      value={showDetails ? editItem.list_factores_criterios[0].peso : ""}

                    />
                  </Col>
                </Row>
                <Form.Label column sm="12" md="12">
                  Año:
                </Form.Label>
                <Row className="d-flex flex-wrap align-items-center">
                  <Col sm={11} xs={11}>
                    <Form.Control
                      type="text"
                      placeholder=""
                      aria-label="Disabled input example"
                      readOnly
                      value={showDetails ? editItem.list_factores_criterios[0].anio : ""}

                    />
                  </Col>
                </Row>
                <h6 className="my-3">Unidad Organizativa</h6>
                <Row className="d-flex flex-wrap align-items-center">
                  <Col sm={11} xs={11}>
                    <Form.Control
                      type="text"
                      placeholder=""
                      aria-label="Disabled input example"
                      readOnly
                      value={showDetails ? editItem.list_unidad_organizativa[0].nombre : ""}

                    />
                  </Col>
                </Row>
                <h6 className="my-3">Responsable</h6>
                <Row className="d-flex flex-wrap align-items-center">
                  <Col sm={11} xs={11}>
                    <Form.Control
                      type="text"
                      placeholder=""
                      aria-label="Disabled input example"
                      readOnly
                      value={showDetails && editItem.list_responsable != null ? editItem?.list_responsable?.[0]?.nombre : "NO HAY UN RESPONSABLE ASOCIADO"}

                    />
                  </Col>
                </Row>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="rounded-pill"
                variant="secondary"
                onClick={() => {
                  setShowDetailsModal(false)
                  setShowDetailsModal(false)
                }}
              >
                Cerrar
              </Button>

            </Modal.Footer>
          </Form>


        </Modal>

        {
          loaderFactorsCriteria || saveLoaderFactorCriterion ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : factorsCriteria && factorsCriteria.length > 0 ? (
            <>
              <Card className="border-0">
                {console.log(factorsCriteria, countSelected)}
                <Card.Body className="px-1 px-sm-2">
                  <div className="mx-1 border-left border-warning">
                    <Alert variant="light">
                      {countSelected < 3 && (
                        <Alert variant="danger">
                          Debe seleccionar un mínimo de 3 criterios aplicables.
                        </Alert>)}           
                      <p>
                        Se han seleccionado {countSelected} factores
                      </p>
                    </Alert>
                  </div>
                  <CustomTable columns={columns} data={factorsCriteria} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={factorsCriteriaLenght}
                pages={pages}
                pagFunc={_getFactorsCriteria}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Sin registros que mostrar.
            </Alert>
          )
        }
      </Container >

    </div >
  );
};

export default FactorsAndCriteria;
